<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :showHeader="showTableHeader"
            :pagination="paginateTable"
            ajax-path="freeradius/auth"
        />        
    </div>
</template>

<script>

    export default {
        props: {
            showTableHeader: {
                type: Boolean,
                default: true,
            },
            paginateTable: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                columns: [
                    {
                        title: 'Username',
                        field: 'username',
                        sorter: 'string',
                        minWidth: 250,
                    },
                    {
                        title: 'Reply',
                        field: 'reply',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Auth Date',
                        field: 'auth_date_for_human',
                        sorter: 'string',
                        minWidth: 200,
                    },
                ],
            }
        },
    }
</script>